import React from 'react'

// components
import {
  CRow,
} from '@coreui/react-pro'
import AppTextColumnDetails from '../../../details/general-details/AppTextColumnDetails'

const AppModalDetails = ({
  letterNumberDetails,
}) => {
  return (
    <>
      <CRow className='mb-3'>
        <AppTextColumnDetails
          colSize="3"
          title="Letter Type"
          subtitle={letterNumberDetails?.letter_type}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Letter Number"
          subtitle={letterNumberDetails?.letter_number}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Letter Month"
          subtitle={letterNumberDetails?.letter_month}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Letter Year"
          subtitle={letterNumberDetails?.letter_year}
        />
      </CRow>
    </>
  )
}

export default AppModalDetails
